export default {
    create_edit_gadget_chart: "Gráfico",
    create_edit_gadget_chart_description: "Gráficos de lineas o de columnas personalizables para resumir los datos del informe",
    create_edit_gadget_edit_gadget: "Editar gadget",
    create_edit_gadget_create_gadget: "Crear gadget",
    create_edit_gadget_changes_saved_sucessfully: "Cambios guardados correctamente",
    create_edit_gadget_pie_title: "Solicitud de clips de VidFleet",
    create_edit_gadget_pie_description: "Gráficos circulares para mostrar el recuento de estados ClipRequest",
    create_edit_gadget_firmware_description: "Gráficos de columnas para resumir los Firmwares asignados a los dispositivos",
    create_edit_gadget_unit_by_status: "Unidades inactivas que siguen informando",
    create_edit_gadget_stopped_reporting: "Unidades activas que dejaron de informar",
    create_edit_gadget_unit_status: "Estado de la unidad",
    create_edit_gadget_maintenance_warnings: "Advertencias de mantenimiento",
}